'use client';
import Image from 'next/image';
import Link from 'next/link';
import { BottomNavigatorContext } from '@/components/organisms/mobile/Reuters.context';
import { useContext } from 'react';
import { PUBLIC } from '@/constants/image/path';
import useFixedCard from '@/store/useFixedCard';

type IconContentProps = {
  src: string;
  title: string;
};

type IconButtonProps = IconContentProps & {
  onClick?: () => void;
};

type IconLinkProps = IconContentProps & {
  link: string;
};

const IconContent = ({ src, title }: IconContentProps) => (
  <>
    <Image src={src} alt='order-button' width={22} height={22} />
    <p className='text-[10px] text-[#515c69]'>{title}</p>
  </>
);

const IconButton = ({ src, title, onClick }: IconButtonProps) => {
  return (
    <button onClick={onClick}>
      <IconContent src={src} title={title} />
    </button>
  );
};

const IconLink = ({ src, title, link }: IconLinkProps) => (
  <Link href={link}>
    <IconContent src={src} title={title} />
  </Link>
);

const onClickShare = () => {
  if (navigator.share) {
    navigator.share({
      title: '路透即時外匯-美元台幣｜Anue鉅亨',
      text: '查看最新的即時外匯資訊，提供免費全球匯率的即時報價、熱門幣別 ${名稱}${股價}${漲跌幅%}、交叉匯率及外匯新聞，是台灣匯率資訊整合最多元的財經網站',
      url: 'www.cnyes.com/forex/reuters'
    });
  }
};

const IconButtons = () => {
  const context = useContext(BottomNavigatorContext);
  const { setComponent, setSymbol } = useFixedCard();

  const onClickComment = () => {
    context?.setStore({ commentIsOpen: true });
  };

  const onClickOrder = () => {
    setComponent('order-card');
  };

  return (
    <ul className='flex flex-1 items-center justify-between'>
      <IconButton src={`${PUBLIC}/icons/bottom-navigator/order.svg`} title='下單' onClick={onClickOrder} />
      <IconLink src={`${PUBLIC}/icons/bottom-navigator/news.svg`} title='新聞' link='#related-news' />
      <IconButton src={`${PUBLIC}/icons/bottom-navigator/chat.svg`} title='聊天' onClick={onClickComment} />
      <IconButton src={`${PUBLIC}/icons/bottom-navigator/share.svg`} title='分享' onClick={onClickShare} />
    </ul>
  );
};

export default IconButtons;
